// import { validationRules } from '../validationRules';
import { ValidateResponse } from '../Validator';

interface NoCellErrorsProps {
    // uiContext: IUiContext;
}

export const NoCellErrors = (props: any): ValidateResponse => {
    const valid = true;

    const response: ValidateResponse = {
        reason: !valid ? `Timesheet must not contain cells with errors. Please review the cells with red borders below.` : null,
        valid: valid,
        name: 'noCellErrors',
        rejected: !valid,
    };

    return response;
};
